import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable()
export class UploadFileService {
  constructor() {}

  uploadfile(file, key: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const bucket = new S3({
        accessKeyId: 'AKIAJKACJTRG7OF3ZINQ',
        secretAccessKey: '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',
        region: 'us-east-1',
      });

      const params = {
        Bucket: 'imsmart-pdfs',
        Key: key,
        Body: file,
        ContentType: file.type,
        ContentLength: file.size,
        ACL: 'public-read',
      };

      bucket.upload(params, (err, data) => {
        if (err) reject(err);
        resolve(data.Location);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/upload-file.service.ts